import { SanitizedSectionArticle } from "@app/types/Cue";
import { useLoadMorePodcastStories } from "@hooks/useLoadMorePodcastStories";

import MorePodcastsStories from "./MorePodcastsStories";

type MorePodcastsProps = {
  articles: SanitizedSectionArticle[];
};

export default function MorePodcasts({
  articles,
}: MorePodcastsProps): React.ReactElement {
  const { articleList, ref } = useLoadMorePodcastStories(articles, 10);

  return (
    <section data-testid="more-podcasts-component">
      <div className="stories divide-y divide-gray-175">
        {articleList.map((article, index) => {
          return (
            <MorePodcastsStories key={article.id} {...{ article, index }} />
          );
        })}
      </div>

      <div ref={ref} />
    </section>
  );
}
